import api from 'api/axios';

function debounceAsync(fn, wait = 1500) {
  let timer = null;
  let pending = [];
  return (...args) =>
    new Promise((resolve, reject) => {
      pending.push({ resolve, reject });
      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        timer = null;
        const callers = pending;
        pending = [];
        try {
          const result = await fn(...args);
          callers.forEach((c) => c.resolve(result));
        } catch (error) {
          callers.forEach((c) => c.reject(error));
        }
      }, wait);
    });
}

export async function getDoctorSpecialization() {
  try {
    const response = await api.get(`/specialization`);
    if (response) return response;
    else throw new Error("Could not get specialization");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getAllTemplate() {
  try {
    const response = await api.get(`/admin/templates/`);
    if (response) return response;
    else throw new Error("Could not get templates");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getSpeacialityTemplates(id) {
  try {
    const response = await api.get(`/admin/templates/${id}`);
    if (response) return response;
    else throw new Error("Could not get templates");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
async function getSearchedDignosesImpl(text) {
  try {
    // One call: drcfo.backend merges the admin-visible masters with the local
    // ICD-10 / SNOMED CT catalogue and returns each option WITH its codes.
    // (Previously this topped up from a public SNOMED server in the browser;
    // that host is retired, and the old mapping discarded the concept code.)
    const response = await api.get(
      `/prescription/diagnosis?search=${encodeURIComponent(text)}&max=20`
    );
    if (!response) throw new Error("Could not get diagnoses");
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export const getSearchedDignoses = debounceAsync(getSearchedDignosesImpl, 1500);



async function getSearchedTreatmentsImpl(text) {
  try {
    const response = await api.get(
      `/prescription/treatment?search=${text}&max=20`
    );
    if (response) return response;
    else throw new Error("Could not get treatment");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export const getSearchedTreatments = debounceAsync(
  getSearchedTreatmentsImpl,
  1500
);
async function getSearchedTestsImpl(text) {
  try {
    const response = await api.get(
      `/admin/templates/tests?search=${text}&max=20`
    );
    if (response) return response;
    else throw new Error("Could not get treatment");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export const getSearchedTests = debounceAsync(getSearchedTestsImpl, 1500);
async function getSearchedDrugsImpl(text) {
  try {
    const response = await api.get(
      `/admin/templates/drugs?search=${text}&max=20`
    );
    if (response) return response;
    else throw new Error("Could not get treatment");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export const getSearchedDrugs = debounceAsync(getSearchedDrugsImpl, 1500);
export async function getallDrugType() {
  try {
    const response = await api.get("/drug_type");
    if (response) return response;
    else throw new Error("Could not get drugType");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getDoses() {
  try {
    const response = await api.get(`/doses_type`);
    if (response) return response;
    else throw new Error("Could not get doses");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getDatabaseReminders() {
  try {
    const response = await api.get("/reminder");
    if (response) return response;
    else throw new Error("Could not get reminders");
  } catch (err) {
    return err.response;
  }
}
export async function getTemplateByID(id) {
  try {
    const response = await api.get(`/prescription/template/${id}`);
    if (response) return response;
    else throw new Error("Could not get template id");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function createTemplate(template) {
  try {
    const response = await api.post(`/admin/templates`, template);
    if (response) return response;
    else throw new Error("Could not create template");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function updateTemplate(template, id) {
  try {
    const response = await api.patch(`/admin/templates/${id}`, template);
    if (response) return response;
    else throw new Error("Could not patch template");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function deleteTemplate(id) {
  try {
    const response = await api.delete(`/admin/templates/${id}`);
    if (response) return response;
    else throw new Error("Could not delete template");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
